import React, {useState, useRef, useEffect} from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { deleteChurchPerson, setViewConfirmModaliInAbout, addPersonAboutSectionX, setSocialLinksFromEditing, editChurchPerson } from 'features/profileChurch/profileChurchSlice'
import AddIcon from '@mui/icons-material/Add';
import  useToggleDropdown  from 'hooks/useToggleDropdown';
import SocialMediaDropdown from './SocialMediaDropdown';
import Loader from 'loaders/Loader';
import { toast } from 'react-toastify';
import { aboutChurchStore } from 'app/aboutChurchStore';
import { setConfirmModalData, setViewConfirmModal } from 'features/modal/modalSlice';
import Modal from '@mui/material/Modal';
import ConfirmModal from 'components/modals/ConfirmModal';
import { useTranslation } from 'react-i18next';

export default function AddPersonForm() {
    const { t } = useTranslation('admin')
    const personDetails = aboutChurchStore(state => state.personDetails)
    const isEditingCard = aboutChurchStore(state => state.isEditingCard)
    const setViewAddPersonModal = aboutChurchStore(state => state.setViewAddPersonModal)
    const personEditDetails = aboutChurchStore(state => state.personEditDetails)
    const setViewPersonCardModal = aboutChurchStore(state => state.setViewPersonCardModal)
    const setIsEditingCard = aboutChurchStore(state => state.setIsEditingCard)
    const setPersonEditDetails = aboutChurchStore(state => state.setPersonEditDetails)
    const setPersonDetails = aboutChurchStore(state => state.setPersonDetails) 
    const dispatch = useDispatch() 

    const [otherRole, setOtherRole] = useState({
        status: false,
        value: ''
    })
    const { viewConfirmModal, confirmModalData }  = useSelector((state) => state.modal)

    const dropdownRef = useRef(null)    
    const [ isDropdownOpen, setIsDropdownOpen ] = useToggleDropdown(dropdownRef)

    const { 
        profileChurch, 
        addPersonLinks, 
        linkIcons,
        addingPersonInAboutLoading,
        addingPersonInAboutSuccess,
        deletingPersonInAboutSuccess,
        deletingPersonInAboutLoading
    } = useSelector((state) => state.profileChurch)

    const { user, admin } = useSelector((state) => state.auth)

    const [fullName, setFullName ] = useState("")
    const [role, setRole ] = useState("")
    const [bio, setBio ] = useState("") 
    const [phone, setNumber ] = useState("")
    const [ imgPrev, setImgPrev ] = useState('')
    const [ imageToUpload, setImageToUpload ] = useState('')
    const [ isImageChanged, setIsImageChanged ] = useState(false)
    const [avatarImage, setAvatarImage ] = useState("https://praysely.blob.core.windows.net/images/prys-avatar.png")

    const [email, setEmail ] = useState("")

    const handleDropdown = () => {
        setIsDropdownOpen.toggle(dropdownRef) 
    }
    

    const handleDelete = () => {
        // setViewPersonCardModal(false)
        dispatch(setConfirmModalData({
            text: t('about.deleteConfirm', { name: personDetails.fullName }),
            handler: () => {
                dispatch(deleteChurchPerson({
                    index: personDetails.index,
                    personName: personDetails.fullName,
                    churchId: profileChurch._id,
                }))
            },
            closeHandler: () => {dispatch(setViewConfirmModal(false))},
            confirmBtnBackgroundHover: 'red',
            extraInfo: t('about.cannotUndo')
        }))
        dispatch(setViewConfirmModal(true))
    }



    const handleRole = (e) => {
        if(e.target.value !== "other") { 
            setRole(e.target.value)
            setOtherRole({status: false, value: ''})
        } else {
            setOtherRole({status: true, value: ''})
            setRole('')
        } 
    }

    const handleImageChange = (e) => { 

        if(isEditingCard){
            setIsImageChanged(true)
        }

        let url = URL.createObjectURL(e.target.files[0])
        setImgPrev({ url: url })
        setImageToUpload(e.target.files[0])
    }

    const handleSubmit = () => {
        const formData = new FormData(); 

        if(!imageToUpload && !isEditingCard) { return toast.error(t('about.required')) }
        if(!fullName) { return toast.error(t('about.required')) }
        if(!role && !otherRole.value) { return toast.error(t('about.required')) }
        if(bio.length > 2000) { return toast.error(t('about.bioMaximum')) }

        formData.append("churchId", profileChurch._id)
        formData.append("fullName", fullName);
        formData.append("phone", phone)
        formData.append("role", role ? role : otherRole.value)
        formData.append("bio", bio) 
        formData.append("email", email)
        formData.append("links", JSON.stringify(addPersonLinks))

        if(isEditingCard){
            if(isImageChanged){
                formData.append("file", imageToUpload)
            }

            formData.append("id", personEditDetails._id)

            return dispatch(editChurchPerson(formData))
        }else{
            formData.append("file", imageToUpload)
            dispatch(addPersonAboutSectionX(formData))            
        }
    } 

    const isImgPreview = Object.keys(imgPrev).length > 0

    useEffect(() => {

        if(isEditingCard && personEditDetails) {
            setAvatarImage(personEditDetails.image)
            setFullName(personEditDetails.fullName)
            setRole(personEditDetails.role)
            setBio(personEditDetails.bio)
            setNumber(personEditDetails.phone)
            dispatch(setSocialLinksFromEditing(personEditDetails.links))
        }
    }, [isEditingCard, personEditDetails])

    useEffect(() => {
       if(addingPersonInAboutSuccess){
        setViewAddPersonModal(false)
       }
    }, [addingPersonInAboutSuccess, setViewAddPersonModal])

    useEffect(() => {
        if(isEditingCard && deletingPersonInAboutSuccess) {
            
            setViewPersonCardModal(false)
            setIsEditingCard(false)
            setPersonEditDetails(null)
            setPersonDetails(null)
            setViewAddPersonModal(false)
        }
    }   , [isEditingCard, deletingPersonInAboutSuccess])

    return (
        <AddPersonFormContainer>  
            <ImageWrapPerson>
                <ImagePlaceholderPerson> 
                { imgPrev ? 
                    ( <ImgPreview src={imgPrev.url} alt={t('about.addImage')} /> )
                    : 
                    (
                        <ImgPreview src={avatarImage} alt={t('about.addImage')} />
                    )
                } 
                </ImagePlaceholderPerson >
                <AddImageBtnsWrapPerson>
                    <AddImageBtnPerson htmlFor="imageUpload">
                        { isImgPreview ? 
                            (
                                <span>{t('about.replaceImage')}</span>
                            )
                            : isEditingCard && personEditDetails ?
                            (
                                <span>{t('about.replaceImage')}</span>
                            )
                            :
                            (
                                <span>{t('about.uploadImage')}</span>
                            )
                        }
                        <input hidden id="imageUpload" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={handleImageChange}/>
                    </AddImageBtnPerson> 

                    { isImgPreview && (
                        <RemoveImagePerson onClick={() => { setImageToUpload(''); setImgPrev('')}}>{t('about.removeImage')}</RemoveImagePerson>
                    )}

                </AddImageBtnsWrapPerson>
            </ImageWrapPerson>


            <RoleInput>
                <label for="role">Role</label>  
                 <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                 }}>
                          
                    <select id="role" onChange={handleRole}>
                        <option value="">{t('about.chooseRole')}</option>
                        <option selected={isEditingCard && personEditDetails.role === 'Pastor'} value="Pastor">Pastor</option>
                        <option selected={isEditingCard && personEditDetails.role === 'Lead Pastor'} value="Lead Pastor">{t('about.roles.leadPastor')}</option>
                        <option selected={isEditingCard && personEditDetails.role === 'Associate Pastor'} value="Associate Pastor">{t('about.roles.associatePastor')}</option>
                        <option selected={isEditingCard && personEditDetails.role === 'Youth Pastor'} value="Youth Pastor">{t('about.roles.youthPastor')}</option>
                        <option selected={isEditingCard && personEditDetails.role === 'Childrens Pastor'} value="Childrens Pastor">{t('about.roles.childrensPastor')}</option>
                        <option selected={isEditingCard && personEditDetails.role === 'Administrative Pastor'} value="Administrative Pastor">{t('about.roles.administrativePastor')}</option>
                        <option value="other">Other</option>
                    </select>
                    {
                        otherRole.status &&
                            (
                                <input
                                    style={{ padding: '10px', marginLeft: '10px', borderRadius: '5px', border: '1px solid grey', outline: 'none'}}
                                    onChange={(e) => setOtherRole({status: true, value: e.target.value})}
                                    type="text" id="role"  name="role" placeholder={t('about.otherRole')}  />
                            )
                    }
                </div> 
            </RoleInput>
            <TextInput>
                <label for="name">Name</label>
                
                <input
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    type="text" id="name"  name="name"  />
            </TextInput>
            <TextInput>
                <label for="bio">Bio</label>
                <textarea 
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                    id="bio" name="bio" rows="4" cols="50"></textarea>
            </TextInput>
            <TextInput>
                <label for="email">Email</label>
                <input 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="text" id="email" name="email"/>
            </TextInput> 
            <TextInput>
                <label for="number">{t('about.phone')}</label>
                <input 
                    value={phone}
                    onChange={(e) => setNumber(e.target.value)}
                    type="text" id="number" name="number"/>
            </TextInput> 
            <TextInput>
                <label for="social">Links</label>
                <SocialButtonWrap >
                    <AddSocialButton  onClick={handleDropdown}><AddIcon/></AddSocialButton>

                        { isDropdownOpen && ( 
                                <SocialMediaDropdown 
                                    // dropdownRef={dropdownRef} 
                                    />
                            )
                        } 
                </SocialButtonWrap>
            </TextInput> 
            <SocialLinkWrap >
            {
                // loop through object of links and display those that have a value
                Object.keys(addPersonLinks).map((key, index) => {
                    if(addPersonLinks[key]){
                        return (
                            <SocialLinkIcons>
                                <SocialLinkLabel>{linkIcons[key]}</SocialLinkLabel>
                                <SocialLink>{addPersonLinks[key]}</SocialLink>
                            </SocialLinkIcons>
                        )
                    }
                }
                )
            }
            </SocialLinkWrap>
            {/* <div>{JSON.stringify(addPersonLinks)}</div> */}


            <SubmitPersonBtn 
                disabled={addingPersonInAboutLoading}
                onClick={handleSubmit}>  
                { addingPersonInAboutLoading ? 
                    (
                        <span> 
                            <Loader />
                        </span>
                    ) 
                    : isEditingCard ?
                    (
                        <span> Update </span>
                    )
                    :
                    (
                        <span>
                            {t('about.addPerson')}
                        </span>
                    )
                }
            </SubmitPersonBtn> 
            {

            ((isEditingCard && user && (user.isOrganization || admin[profileChurch._id])) && (
                <DeletePerson
                    onClick={handleDelete}
                    >
                    {t('about.deleteEntry')}
                </DeletePerson>
            ))
            }


            <Modal
                open={viewConfirmModal}
                style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                onClose={() => dispatch(setViewConfirmModal(false))}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition 
                slotProps={{
                  backdrop: {
                    timeout: 500,
                  },
                }}
                >
                    <ConfirmModal 
                        text={confirmModalData.text}
                        hasCloseHandler={true}
                        handler={confirmModalData.handler}  
                        closeHandler={confirmModalData.closeHandler}  
                        confirmBtnBackgroundHover={confirmModalData.confirmBtnBackgroundHover}
                        extraInfo={confirmModalData.extraInfo}
                        loadingState={deletingPersonInAboutLoading}
                        conditionToCloseModal={deletingPersonInAboutSuccess}
                        />
            </Modal>    



        </AddPersonFormContainer>   
    )
}

const DeletePerson = styled.div`
    cursor: pointer; 
    margin-top: 20px;
    bottom: 20px;
    right: 20px;
    width: fit-content;
    background-color: red;
    padding: 10px 15px;
    border-radius: 5px;
    color: white;
    font-size: 11px;
    &:hover{
        
        text-decoration: underline;
    }
`

const AddPersonFormContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;
    @media (max-width: 768px) {
        padding: 10px;
    }
`
const RoleInput = styled.div`
    margin-top: 20px;
    width: 100%; 
    display: flex;
    flex-direction: column; 
    align-items: flex-start;
    justify-content: flex-start;
    select{
        border: 1px solid grey;
        padding: 10px;
        outline: none;
        border-radius: 5px;
    }
    option{
        padding: 10px;
    }
`
const TextInput = styled.div`
    margin-top: 20px;
    width: 80%;
    height: fit-content;
    display: flex;
    flex-direction: column; 
    align-items: flex-start;
    justify-content: flex-start;
    input{
        border: 1px solid grey;
        padding: 10px;
        outline: none;
        border-radius: 5px;
        width: 100%
    }
    textarea{
        border: 1px solid grey;
        padding: 10px;
        outline: none;
        border-radius: 5px;
        font-family: Arial, Helvetica, sans-serif;
        width: 100%
    }

`

const AddImageBtnsWrapPerson = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`
const RemoveImagePerson = styled.div`
    padding-left: 5px;
    cursor: pointer;
    font-size: 11px;
    color: rgb(80,80,80);
    &:hover{
      text-decoration: underline;
    }
`
const ImagePlaceholderPerson = styled.div`
    width: 100%;
    height: auto;
    background-color: rgb(200,200,200);
    border: 1px solid grey;
    margin-bottom: 2px;
    border-radius: 8px;
`

const ImageWrapPerson = styled.div`
    width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    cursor: pointer;
`

const ImgPreview = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 8px;
`

const AddImageBtnPerson = styled.label`
    display: flex;
    align-self: center;
    font-size: 10px;
    height: fit-content;
    width: fit-content;
    padding: 10px;
    background-color: grey;
    color: white;
    border-radius: 5px;
    margin: 2px;
    cursor: pointer;
    &:hover{
        background-color: green;
      
    }
`

const SocialButtonWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content:    flex-start;
    align-items: center;
    position: relative;
`
const AddSocialButton = styled.div` 
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    height: 30px;
    width: 30px; 
    background-color: grey;
    color: white;
    border-radius: 5px; 
    cursor: pointer;
    &:hover{
        background-color: green;
    }
`

const SubmitPersonBtn = styled.div`
    margin-top: 20px;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--btnSubmit);
    color: white;
    border-radius: 5px;
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
    cursor: pointer;
    &:hover{
        opacity: 0.8;
    }
`



const SocialLink = styled.div`
    margin-left: 10px;
    font-size: 12px;
    height: fit-content;
`

const SocialLinkLabel = styled.div`
`
const SocialLinkWrap = styled.div`
`

const SocialLinkIcons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 10px;
`
